/** Label en kleur per match-signaal van de klant-resolver (customer-resolver.ts). */
export type KlantSignaal = 'phone' | 'email' | 'phone_and_email' | 'zelfde_mailbox' | 'naam_adres';

export function klantSignaalLabel(signal: KlantSignaal | string): string {
  switch (signal) {
    case 'phone_and_email': return 'Sterk';
    case 'zelfde_mailbox': return 'Zelfde mailbox';
    case 'naam_adres': return 'Naam + adres';
    case 'email': return 'E-mail';
    case 'phone': return 'Telefoon';
    default: return signal;
  }
}

export function klantSignaalKleur(signal: KlantSignaal | string): string {
  return signal === 'phone_and_email' || signal === 'zelfde_mailbox'
    ? 'bg-emerald-100 text-emerald-700'
    : signal === 'naam_adres'
      ? 'bg-sky-100 text-sky-700'
      : 'bg-slate-100 text-slate-600';
}
